import axios from '@/request';
import qs from 'qs';

export default {
    async categories(params: any) {
        return axios.get('admin-notice/categories', { params })
    },
    async list(params: any) {
        return axios.get('admin-notice/list', { params });
    },
    async detail(params: any) {
        return axios.get('admin-notice/detail', { params })
    }
}
